(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fossilpaws-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.fpReady === 'true') return;
      root.dataset.fpReady = 'true';

      const mainImage = root.querySelector('.fp-gallery__image');
      const thumbs = [...root.querySelectorAll('[data-fp-thumb]')];
      let galleryIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

      const showGalleryImage = (nextIndex) => {
        if (!mainImage || !thumbs.length) return;
        galleryIndex = (nextIndex + thumbs.length) % thumbs.length;
        const thumb = thumbs[galleryIndex];
        const swap = () => {
          thumbs.forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumb.dataset.image;
          mainImage.alt = thumb.dataset.alt || '';
        };
        if (document.startViewTransition) document.startViewTransition(swap);
        else swap();
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => showGalleryImage(index));
      });
      root.querySelector('[data-fp-gallery-prev]')?.addEventListener('click', () => showGalleryImage(galleryIndex - 1));
      root.querySelector('[data-fp-gallery-next]')?.addEventListener('click', () => showGalleryImage(galleryIndex + 1));

      const petTrack = root.querySelector('[data-fp-pet-track]');
      const petSlides = [...root.querySelectorAll('[data-fp-pet-slide]')];
      const petCurrent = root.querySelector('[data-fp-pet-current]');
      let petIndex = 0;

      const showPetSlide = (nextIndex) => {
        if (!petTrack || !petSlides.length) return;
        petIndex = (nextIndex + petSlides.length) % petSlides.length;
        petSlides[petIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (petCurrent) petCurrent.textContent = String(petIndex + 1);
      };

      root.querySelector('[data-fp-pet-prev]')?.addEventListener('click', () => showPetSlide(petIndex - 1));
      root.querySelector('[data-fp-pet-next]')?.addEventListener('click', () => showPetSlide(petIndex + 1));
      petTrack?.addEventListener('scroll', () => {
        window.requestAnimationFrame(() => {
          const left = petTrack.scrollLeft;
          petIndex = petSlides.reduce((closest, slide, index) => {
            const currentDistance = Math.abs((slide.offsetLeft - petTrack.offsetLeft) - left);
            const closestDistance = Math.abs((petSlides[closest].offsetLeft - petTrack.offsetLeft) - left);
            return currentDistance < closestDistance ? index : closest;
          }, 0);
          if (petCurrent) petCurrent.textContent = String(petIndex + 1);
        });
      }, { passive: true });

      const variantInput = root.querySelector('[data-fp-variant-input]');
      const offerProperty = root.querySelector('[data-fp-offer-property]');
      const price = root.querySelector('[data-fp-price]');
      const compare = root.querySelector('[data-fp-compare]');
      const atcPrice = root.querySelector('[data-fp-atc-price]');
      const stickyPrice = root.querySelector('[data-fp-sticky-price]');
      const shippingNote = root.querySelector('[data-fp-shipping-note]');

      const updateSizes = (count) => {
        root.querySelectorAll('[data-fp-size-row]').forEach((row) => {
          const active = Number(row.dataset.fpSizeRow) <= count;
          row.classList.toggle('is-hidden', !active);
          const select = row.querySelector('select');
          if (select) select.disabled = !active;
        });
      };

      root.querySelectorAll('[data-fp-bundle]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-fp-bundle]').forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          if (variantInput) variantInput.value = button.dataset.variantId;
          if (price) price.textContent = button.dataset.price;
          if (compare) compare.textContent = button.dataset.compare || '';
          if (atcPrice) atcPrice.textContent = button.dataset.price;
          if (stickyPrice) stickyPrice.textContent = button.dataset.price;
          if (offerProperty) offerProperty.value = button.dataset.offer || '';
          if (shippingNote) shippingNote.textContent = `✓ ${button.dataset.shipping || 'Tracked shipping'}`;
          updateSizes(Number(button.dataset.packCount || 1));
        });
      });

      const selected = root.querySelector('[data-fp-bundle].is-selected');
      if (selected) {
        updateSizes(Number(selected.dataset.packCount || 1));
        if (offerProperty) offerProperty.value = selected.dataset.offer || '';
        if (shippingNote) shippingNote.textContent = `✓ ${selected.dataset.shipping || 'Tracked shipping'}`;
      }

      const sizeDialog = root.querySelector('[data-fp-size-dialog]');
      root.querySelectorAll('[data-fp-size-open]').forEach((button) => {
        button.addEventListener('click', () => sizeDialog?.showModal());
      });
      root.querySelectorAll('[data-fp-size-close]').forEach((button) => {
        button.addEventListener('click', () => sizeDialog?.close());
      });

      const menuDialog = root.querySelector('[data-fp-menu-dialog]');
      const cartDialog = root.querySelector('[data-fp-cart-dialog]');
      const backdrop = root.querySelector('[data-fp-drawer-backdrop]');
      const setDrawerState = (open) => {
        backdrop?.classList.toggle('is-active', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };

      const closeDrawer = (dialog) => {
        if (dialog?.open) dialog.close();
        if (!menuDialog?.open && !cartDialog?.open) setDrawerState(false);
      };

      const openDrawer = (dialog) => {
        if (!dialog) return;
        if (dialog === menuDialog) closeDrawer(cartDialog);
        if (dialog === cartDialog) closeDrawer(menuDialog);
        if (!dialog.open) dialog.showModal();
        setDrawerState(true);
      };

      root.querySelector('[data-fp-menu-open]')?.addEventListener('click', () => openDrawer(menuDialog));
      root.querySelectorAll('[data-fp-menu-close]').forEach((button) => {
        button.addEventListener('click', () => closeDrawer(menuDialog));
      });
      root.querySelectorAll('[data-fp-cart-close]').forEach((button) => {
        button.addEventListener('click', () => closeDrawer(cartDialog));
      });
      backdrop?.addEventListener('click', () => {
        closeDrawer(menuDialog);
        closeDrawer(cartDialog);
      });

      const base = window.Shopify?.routes?.root || '/';
      const money = (cents) => {
        const currency = window.Shopify?.currency?.active || 'USD';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
      };

      const bundleButtons = [...root.querySelectorAll('[data-fp-bundle]')];
      const normalizeVariantId = (value) => String(value || '').split('/').pop();
      const bundleForVariant = (variantId) => {
        const normalizedId = normalizeVariantId(variantId);
        return bundleButtons.find((button) => normalizeVariantId(button.dataset.variantId) === normalizedId);
      };
      const packForItem = (item) => Number(bundleForVariant(item.variant_id)?.dataset.packCount || 1);
      const cartError = root.querySelector('[data-fp-cart-error]');
      const setCartError = (message = '') => {
        if (!cartError) return;
        cartError.textContent = message;
        cartError.classList.toggle('is-active', Boolean(message));
      };

      const renderCartSizes = (item, packCount) => {
        const sizesNode = root.querySelector('[data-fp-cart-sizes]');
        if (!sizesNode) return;
        const labels = {
          S: 'S — 1–2.5 kg',
          M: 'M — 2.5–4 kg',
          L: 'L — 4–6 kg',
          XL: 'XL — 6–9 kg'
        };
        sizesNode.innerHTML = Array.from({ length: packCount }, (_, index) => {
          const number = index + 1;
          const current = item.properties?.[`Pet ${number} size`] || '';
          const options = Object.entries(labels).map(([value, label]) => (
            `<option value="${value}"${current === value ? ' selected' : ''}>${label}</option>`
          )).join('');
          return `<label class="fp-cart-size-field"><span>PET ${number} SIZE</span><select data-fp-cart-size="${number}" required><option value=""${current ? '' : ' selected'} disabled>CHOOSE SIZE</option>${options}</select></label>`;
        }).join('');
      };

      const renderCart = (cart) => {
        const item = cart.items.find((entry) => entry.handle === 'glowrex-dinosaur-skeleton-pet-costume');
        const itemNode = root.querySelector('[data-fp-cart-item]');
        const emptyNode = root.querySelector('[data-fp-cart-empty]');
        const upgradeNode = root.querySelector('[data-fp-cart-upgrade]');
        const checkout = root.querySelector('.fp-cart-checkout');
        const cartDisplayCount = cart.items.reduce((total, entry) => {
          if (entry.handle === 'glowrex-dinosaur-skeleton-pet-costume') return total + (packForItem(entry) * entry.quantity);
          return total + entry.quantity;
        }, 0);
        root.querySelectorAll('[data-fp-cart-count]').forEach((node) => { node.textContent = cartDisplayCount; });
        setCartError('');

        if (!item) {
          itemNode?.setAttribute('hidden', '');
          emptyNode?.classList.add('is-active');
          upgradeNode?.setAttribute('hidden', '');
          if (checkout) checkout.setAttribute('aria-disabled', 'true');
          const subtotal = root.querySelector('[data-fp-cart-subtotal]');
          if (subtotal) subtotal.textContent = money(0);
          return;
        }

        itemNode?.removeAttribute('hidden');
        emptyNode?.classList.remove('is-active');
        upgradeNode?.removeAttribute('hidden');
        if (checkout) checkout.removeAttribute('aria-disabled');
        const packCount = packForItem(item);
        if (itemNode) {
          itemNode.dataset.cartKey = item.key;
          itemNode.dataset.variantId = String(item.variant_id);
          itemNode.dataset.packCount = String(packCount);
          itemNode.dataset.itemQuantity = String(item.quantity);
        }

        const image = root.querySelector('[data-fp-cart-image]');
        const itemImage = item.featured_image?.url || item.image;
        if (image && itemImage) {
          image.src = itemImage;
          image.alt = item.product_title || 'GlowRex costume';
        }
        const title = root.querySelector('[data-fp-cart-title]');
        if (title) title.textContent = item.product_title;
        const offer = item.properties?.Offer || item.variant_title || 'Buy 1';
        const offerNode = root.querySelector('[data-fp-cart-offer]');
        if (offerNode) offerNode.textContent = offer;

        renderCartSizes(item, packCount);
        const quantityNode = root.querySelector('[data-fp-cart-quantity]');
        if (quantityNode) quantityNode.textContent = String(packCount);
        const quantityLabel = quantityNode?.parentElement?.querySelector('small');
        if (quantityLabel) quantityLabel.textContent = packCount === 1 ? 'COSTUME' : 'COSTUMES';
        const minus = root.querySelector('[data-fp-cart-minus]');
        const plus = root.querySelector('[data-fp-cart-plus]');
        if (minus) minus.disabled = packCount <= 1;
        if (plus) plus.disabled = packCount >= 5;

        const priceNode = root.querySelector('[data-fp-cart-price]');
        if (priceNode) priceNode.textContent = money(item.final_line_price);
        const originalNode = root.querySelector('[data-fp-cart-original]');
        const matchingBundle = bundleForVariant(item.variant_id);
        if (originalNode) originalNode.textContent = matchingBundle?.dataset.compare || '';
        const subtotal = root.querySelector('[data-fp-cart-subtotal]');
        if (subtotal) subtotal.textContent = money(cart.items_subtotal_price);

        const freeShipping = packCount > 1;
        const unlock = root.querySelector('[data-fp-cart-unlock]');
        if (unlock) unlock.textContent = freeShipping ? 'FREE TRACKED SHIPPING UNLOCKED ✓' : 'Choose a multi-pack to unlock FREE SHIPPING';

        const upgradeButtons = [...root.querySelectorAll('[data-fp-cart-upgrade-button]')];
        upgradeButtons.forEach((button) => {
          button.hidden = Number(button.dataset.packCount) <= packCount;
        });
        if (upgradeNode) upgradeNode.hidden = !upgradeButtons.some((button) => !button.hidden);
      };

      const fetchCart = async () => {
        const response = await fetch(`${base}cart.js`, {
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Unable to load cart');
        const cart = await response.json();
        renderCart(cart);
        return cart;
      };

      const readCartSizes = (targetCount) => {
        const values = [...root.querySelectorAll('[data-fp-cart-size]')].map((select) => select.value || '');
        return Array.from({ length: targetCount }, (_, index) => values[index] || '');
      };

      const propertiesForOffer = (offer, packCount) => {
        const properties = { Offer: offer };
        readCartSizes(packCount).forEach((value, index) => {
          properties[`Pet ${index + 1} size`] = value;
        });
        return properties;
      };

      const replaceCartOffer = async (variantId, packCount, offer) => {
        const itemNode = root.querySelector('[data-fp-cart-item]');
        if (root.dataset.fpCartBusy === 'true') return;
        if (normalizeVariantId(itemNode?.dataset.variantId) === normalizeVariantId(variantId)) return;
        root.dataset.fpCartBusy = 'true';
        cartDialog?.setAttribute('aria-busy', 'true');
        setCartError('');
        try {
          const addResponse = await fetch(`${base}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: normalizeVariantId(variantId),
                quantity: 1,
                properties: propertiesForOffer(offer, packCount)
              }]
            })
          });
          if (!addResponse.ok) throw new Error('Unable to add the selected offer');

          if (itemNode?.dataset.cartKey) {
            const removeResponse = await fetch(`${base}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: itemNode.dataset.cartKey, quantity: 0 })
            });
            if (!removeResponse.ok) throw new Error('Unable to replace the previous offer');
            renderCart(await removeResponse.json());
          } else {
            await fetchCart();
          }
        } catch (error) {
          await fetchCart().catch(() => {});
          setCartError('We could not update the offer. Please try again.');
        } finally {
          root.dataset.fpCartBusy = 'false';
          cartDialog?.removeAttribute('aria-busy');
        }
      };

      const saveCartSizes = async () => {
        const itemNode = root.querySelector('[data-fp-cart-item]');
        if (!itemNode?.dataset.cartKey || root.dataset.fpCartBusy === 'true') return;
        const packCount = Number(itemNode.dataset.packCount || 1);
        const offer = root.querySelector('[data-fp-cart-offer]')?.textContent || 'BUY 1';
        root.dataset.fpCartBusy = 'true';
        setCartError('');
        try {
          const response = await fetch(`${base}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: itemNode.dataset.cartKey,
              quantity: Number(itemNode.dataset.itemQuantity || 1),
              properties: propertiesForOffer(offer, packCount)
            })
          });
          if (!response.ok) throw new Error('Unable to save sizes');
          renderCart(await response.json());
        } catch (error) {
          setCartError('Your size selection was not saved. Please try again.');
        } finally {
          root.dataset.fpCartBusy = 'false';
        }
      };

      root.querySelectorAll('[data-fp-cart-open]').forEach((button) => {
        button.addEventListener('click', async () => {
          try {
            await fetchCart();
            openDrawer(cartDialog);
          } catch (error) {
            window.location.href = `${base}cart`;
          }
        });
      });

      root.querySelector('[data-fp-cart-remove]')?.addEventListener('click', async () => {
        const itemNode = root.querySelector('[data-fp-cart-item]');
        if (!itemNode?.dataset.cartKey || root.dataset.fpCartBusy === 'true') return;
        root.dataset.fpCartBusy = 'true';
        cartDialog?.setAttribute('aria-busy', 'true');
        setCartError('');
        try {
          const response = await fetch(`${base}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: itemNode.dataset.cartKey, quantity: 0 })
          });
          if (!response.ok) throw new Error('Unable to remove item');
          renderCart(await response.json());
        } catch (error) {
          setCartError('We could not remove this item. Please try again.');
        } finally {
          root.dataset.fpCartBusy = 'false';
          cartDialog?.removeAttribute('aria-busy');
        }
      });

      root.querySelector('[data-fp-cart-sizes]')?.addEventListener('change', (event) => {
        if (event.target.matches('[data-fp-cart-size]')) saveCartSizes();
      });

      root.querySelector('[data-fp-cart-minus]')?.addEventListener('click', () => {
        const current = Number(root.querySelector('[data-fp-cart-item]')?.dataset.packCount || 1);
        const options = bundleButtons.map((button) => Number(button.dataset.packCount)).sort((a, b) => a - b);
        const target = [...options].reverse().find((count) => count < current);
        const bundle = bundleButtons.find((button) => Number(button.dataset.packCount) === target);
        if (bundle) replaceCartOffer(bundle.dataset.variantId, target, bundle.dataset.offer || 'BUY 1');
      });

      root.querySelector('[data-fp-cart-plus]')?.addEventListener('click', () => {
        const current = Number(root.querySelector('[data-fp-cart-item]')?.dataset.packCount || 1);
        const options = bundleButtons.map((button) => Number(button.dataset.packCount)).sort((a, b) => a - b);
        const target = options.find((count) => count > current);
        const bundle = bundleButtons.find((button) => Number(button.dataset.packCount) === target);
        if (bundle) replaceCartOffer(bundle.dataset.variantId, target, bundle.dataset.offer || 'BUY 1');
      });

      root.querySelectorAll('[data-fp-cart-upgrade-button]').forEach((button) => {
        button.addEventListener('click', () => {
          replaceCartOffer(button.dataset.variantId, Number(button.dataset.packCount), button.dataset.offer);
        });
      });

      root.querySelectorAll('[data-fp-cart-shop]').forEach((button) => {
        button.addEventListener('click', () => {
          closeDrawer(cartDialog);
          root.querySelector('#shop')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      root.querySelector('.fp-cart-checkout')?.addEventListener('click', (event) => {
        if (event.currentTarget.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          setCartError('Choose an offer before checkout.');
          return;
        }
        const missing = [...root.querySelectorAll('[data-fp-cart-size]')].find((select) => !select.value);
        if (!missing) return;
        event.preventDefault();
        setCartError('Choose a size for every costume before checkout.');
        missing.focus();
      });

      const form = root.querySelector('.fp-product-form');
      const atc = root.querySelector('[data-fp-atc]');
      if (form && atc) {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const original = atc.innerHTML;
          atc.disabled = true;
          atc.innerHTML = '<span>ADDING…</span><span>✦</span>';
          try {
            const response = await fetch(`${base}cart/add.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });
            if (!response.ok) throw new Error('Unable to add');
            await response.json();
            await fetchCart();
            openDrawer(cartDialog);
          } catch (error) {
            atc.innerHTML = '<span>TRY AGAIN</span><span>↻</span>';
            window.setTimeout(() => { atc.innerHTML = original; }, 1800);
          } finally {
            atc.disabled = false;
            if (atc.textContent.includes('ADDING')) atc.innerHTML = original;
          }
        });
      }

      root.querySelector('[data-fp-sticky]')?.addEventListener('click', () => {
        document.querySelector('#shop')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      menuDialog?.addEventListener('close', () => {
        if (!cartDialog?.open) setDrawerState(false);
      });
      cartDialog?.addEventListener('close', () => {
        if (!menuDialog?.open) setDrawerState(false);
      });
    };

    document.querySelectorAll('[data-fp-root]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-fp-root]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
